<template>
  <div>
    <div
      v-if="showMode"
      class="cxfxClass onePictureDialog queryLayerDialog dy3dDialog"
      id="searchStep_2"
    >
      <div class="headerClass">
        <div class="headerTitle tixing">
          <span>查询分析</span>
        </div>

        <div class="boxClose">
          <img
            :src="require('@/assets/images/poscloseIcon.png')"
            style="cursor: pointer"
            @click="close()"
          />
        </div>
      </div>

      <img
        class="splitLine"
        :src="require('@/assets/images/splitlineIcon.png')"
      />

      <div class="fwToolClass">
        <div>
          <a-col :span="4"><span>当前图层：</span></a-col>
          <a-col :span="20">
            <a-input
              class="inputArea"
              v-model="selectedNodeName"
              disabled
            ></a-input>
          </a-col>
        </div>
        <div>
          <a-col :span="4"><span>选择字段：</span></a-col>
          <a-col :span="20">
            <div class="selectBox" ref="selectBox">
              <a-select
                v-model="attrValue"
                :getPopupContainer="() => this.$refs.selectBox"
                :notFoundContent="'暂无数据'"
              >
                <a-select-option
                  v-for="(item, index) in selectedNodeAttr"
                  :key="index"
                  :value="item.name"
                  :title="item.alias"
                >
                  {{ item.alias }}
                </a-select-option>
              </a-select>
            </div>
          </a-col>
        </div>
        <div>
          <a-col :span="4"><span>查询属性：</span></a-col>
          <a-col :span="20">
            <a-input class="inputArea" v-model="queryAttr"></a-input>
          </a-col>
        </div>
        <div>
          <a-col :span="4"><span>操作：</span></a-col>
          <a-col :span="20">
            <a-button
              class="searchBtn"
              type="primary"
              :loading="searchLoading"
              @click="queryAttrForLayer"
              >查询</a-button
            >
            <a-button class="emptyBtn" style="margin-left: 3%" @click="clearAll"
              >清空</a-button
            >
          </a-col>
        </div>
      </div>
      <div class="query oprateInfo">
        <a-table
          bordered
          size="middle"
          rowKey="bsm"
          :scroll="{ x: 400, y: 'calc(100% - 42px)' }"
          :columns="columns"
          :data-source="queryResultList"
          :pagination="false"
        >
          <template slot="name" slot-scope="text">
            <div>{{ text || " " }}</div>
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="flyToPosition(record)">定位</a>
            <a-divider type="vertical" />
            <a @click="checkDetails(record)">查看</a>
          </span>
        </a-table>
      </div>
      <div class="attrDialog">
        <MapDetailCard ref="mapDetailCard"></MapDetailCard>
      </div>
    </div>
    <div v-show="hideMode" class="tdfxhzClass2">
      <div class="headerClass">
        <span @click="menFold()">
          <a-icon type="menu-fold" style="color: aliceblue; cursor: pointer" />
        </span>
      </div>
    </div>
  </div>
</template>
  
<script>
  import { guide } from "../../../../utils/beginnerGuide";
  import Vue from "vue";
  import "proj4leaflet";
  const esri = require("esri-leaflet");
  import MapDetailCard from "../../../components/MapDetailCard.vue";
  import { HandleTableCells } from "../../../../mixins/HandleTableCells";
  import { transAttr } from '../../../js/transAttr.js'
  export default {
    name: "tdfxhzDialog",
    components: {
      MapDetailCard,
    },
    mixins: [HandleTableCells],
    data() {
      return {
        searchLoading: false,
        showMode: false,
        hideMode: false,

        myTitle: "分析结果",
        tucengValue: "",
        attriArray: [], //字段数组
        // 图斑数据
        layerParams: [],
        fwArry: [],
        // condition测试数据
        condition: [],
        // 表格数据
        tableData: [],
        selectLayerBsm: "", //选择的图层bsm
        attrValue: "",
        queryAttr: "",
        queryResult: {},
        queryResultList: [],
        columns: [
          {
            title: "名称",
            dataIndex: "name",
            align: "center",
            width: 300,
            scopedSlots: { customRender: "name" },
          },
          {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            align: "center",
          },
        ],
        selectedNodeName: "",
        selectedNodeAttr: [],
      };
    },
    props: {
      selectedNode: {
        type: Object,
        default: () => {},
      },
    },
    watch: {
      selectedNode(newValue, oldValue) {
        console.log("change", newValue, oldValue);
        if (newValue) {
          this.selectedNodeName = newValue.name || newValue.title;
          this.selectedNodeAttr = newValue.attributes
            ? newValue.attributes
            : (newValue.gisLayers ? newValue.gisLayers[0].attributes : []);
        }
      },
      queryResultList(newValue, oldValue) {
        this.$nextTick(() => {
          this.changeOddTrBg();
        });
      },
    },
    methods: {
      close() {
        this.showMode = false;
        // 清除绘制的图形
        if (this.map) {
          this.graphicLayer.clear();
          this.geojsonLayer.clear();
          // 清除汇总分析里选择和手绘的图斑数据
          this.map.getLayers().map((layer) => {
            if (
              layer.options.name == "geojson查询" ||
              layer.options.name == "graphic查询"
            ) {
              this.map.removeLayer(layer);
            }
          });
        }

      this.attrValue = "";
      this.queryAttr = "";
      this.queryResult = {};
      this.queryResultList = [];
    },
    // 分析弹框展开
    menFold() {
      this.showMode = true;
      this.hideMode = false;
    },
    setMap(map) {
      this.map = map;
      this.showMode = true;
      this.geojsonLayer = new mars3d.layer.GeoJsonLayer({
        name: "geojson查询",
        symbol: {
          type: "polygonP",
          styleOptions: {
            color: "#3388ff",
            opacity: 0.3,
            outline: true,
            outlineWidth: 2,
            outlineColor: "#3388ff",
            clampToGround: true,
          },
        },
        flyTo: true,
      });
      this.graphicLayer = new mars3d.layer.GraphicLayer({
        name: "graphic查询",
      });
      this.map.addLayer(this.geojsonLayer);
      this.map.addLayer(this.graphicLayer);
      // this.tucengValue = this.selectedNode.name
      console.log("selectedNode", this.selectedNode);
      // this.$nextTick(() => {
      //   if (Vue.ls.get("Intro_yztcx_status") !== "false") {
      //     guide("一张图-查询", "一张图-查询", "Intro_yztcx_status");
      //   }
      // });
    },
    queryAttrForLayer() {
      const that = this;
      console.log("attrValue", this.attrValue,this.selectedNodeName);
      that.clearAll()
      if(!(this.selectedNodeName && this.attrValue && this.queryAttr)){
        this.$message.warning('请先选择/填写查询条件')
        return
      }
      this.searchLoading = true;
      if (this.selectedNode.serviceUrl) {
        let queryMapserver = new mars3d.query.QueryArcServer({
          url: `${this.selectedNode.serviceUrl}/${this.selectedNode.id}`,
        });
        queryMapserver.query({
          column: this.attrValue,
          text: this.queryAttr,
          page: false,
          success: (result) => {
            that.searchLoading = false;
            if (result.count === 0) {
              that.$message.warning("未查询到相关记录!");
              return;
            }
            console.log("查询到的记录", result);

              that.geojsonLayer.load({ data: result.geojson });
              that.queryResult = result.geojson;

              result.geojson.features.forEach((feature) => {
                for (let key in feature.properties) {
                  if (key == that.attrValue) {
                    feature.properties.attrName = feature.properties[key];
                  }
                }
                let obj = {};
                obj.name = feature.properties.attrName;
                obj.id = feature.id;
                obj.geometry = feature.geometry;
                obj.properties = feature.properties;
                that.queryResultList.push(obj);
              });

              // that.queryResultList
            },
          });
        } else if (this.selectedNode.layerUrl.includes("geoserver")) {
          console.log("this.selectedNode", this.selectedNode);
          let queryMapserver = new mars3d.query.QueryGeoServer({
            // "http://192.168.1.16:9090/geoserver/wfs",
            url:"http://" + this.selectedNode.layerUrl.split('/')[2] + "/geoserver/wfs",
            layer: this.selectedNode.alias,
          });
          queryMapserver.query({
            column: this.attrValue.toLowerCase(),
            text: this.queryAttr,
            success: (result) => {
              that.searchLoading = false;
              if (result.count === 0) {
                that.$message.warning("未查询到相关记录!");
                return;
              }

              console.log("result", result);
              that.geojsonLayer.load({ data: result.geojson });
              that.queryResult = result.geojson;

              result.geojson.features.forEach((feature) => {
                for (let key in feature.properties) {
                  if (key == that.attrValue.toLowerCase()) {
                    feature.properties.attrName = feature.properties[key];
                  }
                }
                let obj = {};
                obj.name = feature.properties.attrName;
                obj.id = feature.id;
                obj.geometry = feature.geometry;
                obj.properties = feature.properties;
                that.queryResultList.push(obj);
              });
            },
          });
        }
      },
      clearAll() {
        this.graphicLayer.clear();
        this.geojsonLayer.clear();
        this.queryResultList = [];
      },
      // 表格行定位
      flyToPosition(record) {
        this.graphicLayer.clear();
        console.log("record", record);
        const graphic = new mars3d.graphic.PolygonEntity({
          positions:
            record.geometry.type == "MultiPolygon"
              ? record.geometry.coordinates[0][0]
              : record.geometry.coordinates,
          style: {
            color: "#3388ff",
            opacity: 0.5,
            outline: true,
            outlineWidth: 2,
            outlineColor: "#3388ff",
            clampToGround: true,
          },
        });

        this.graphicLayer.addGraphic(graphic);
        graphic.flyTo({
          scale: 3,
          duration: 0.8,
        });
      },
      // 表格行查看
      checkDetails(record) {
        if (record.properties) {
          // let attributeArr = [];
          // var list = record.properties;
          // var array = [];
          // array = Object.keys(list).map((val) => ({
          //   key: val,
          //   value: list[val],
          //   show: true,
          // }));
          // array.forEach((arr) => {
          //   this.selectedNode.attributes.forEach((attr) => {
          //     if (arr.key == attr.name.toLowerCase()) {
          //       let obj = {
          //         key: arr.key,
          //         value: arr.value,
          //         show: arr.show,
          //         alias: attr.alias,
          //         orderNo: attr.orderNo,
          //         type: "mvt",
          //       };
          //       attributeArr.push(obj);
          //     }
          //   });
          // });
          let attributeArr = transAttr(record.properties,this.selectedNode.attributes,'mvt')
          this.$refs.mapDetailCard.openDetail(
            attributeArr,
            record.properties.attrName || ""
          );
        }
      },
      // 恢复弹框显示
      rebackShow(obj) {
        this.$refs.analysisResult.setMap(
          this.myTitle,
          obj.tabData,
          obj.goemObj,
          obj.tcValue,
          obj.shpata,
          obj.size,
          this.map
        );
      },
    },
  };
</script>
  
<style lang="less" scoped>
/**infoview浮动面板*/
.tdfxhzClass2 {
  position: absolute;
  top: 40px;
  width: 40px;
  right: 0px;
  // padding: 0px 15px;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(43, 73, 114, 1);
  box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
  .headerClass {
    width: 100%;
    height: 40px;
    // background-color: #2b4972;
    opacity: 0.8;
    line-height: 40px;
    display: flex;
    justify-content: center;
  }
}
.cxfxClass {
  position: absolute;
  top: 45px;
  width: 500px;
  max-width: 500px;
  height: calc(100% - 77px);
  right: 10px;
  border-radius: 4px;
  color: #ffffff;
  backdrop-filter: blur(15px);
  z-index: 999;
  display: flex;
  flex-direction: column;
  .headerClass {
    position: relative;
  }
  .splitLine {
    margin: 10px 0;
  }
  .fwToolClass {
    height: 22%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    & > div {
      display: flex;
      align-items: center;
    }
    .inputArea {
      width: 85%;
      background-color: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
    .selectBox {
      width: 85%;
      /deep/ .ant-select {
        width: 100%;
      }
    }
  }
  .oprateInfo {
    width: 100%;
    height: calc(78% - 62px);
    margin-top: 10px;
  }
  .selectFw {
    color: #27f181;
    margin-top: 8px;
    margin-left: 8px;
  }
  .selectKjsf {
    color: #27f181;
    margin-left: 8px;
  }
  .kjsfClass {
    width: 100%;
    margin-top: 8px;
    padding-left: 10px;
  }
  .selectTc {
    color: #27f181;
    margin-top: 8px;
    margin-bottom: 5px;
    margin-left: 8px;
  }
  .infoShowClass {
    display: flex;
    align-items: center;
    width: 98%;
    height: 5%;
    position: absolute;
    bottom: 1%;
    left: 1%;
    padding-left: 7%;
    border-radius: 8px;
    .infoItem {
      margin-right: 1%;
      .circle {
        width: 6px;
        height: 6px;
        background: #2ef197;
        border-radius: 50%;
        position: absolute;
        top: 39%;
        left: -15px;
      }
    }
  }
  .treeSelect {
    width: 98% !important;
    margin-top: 5px;
  }
  .editInfo {
    width: 100%;
    color: #27f181;
    padding-top: 15px;
    padding-left: 8px;
    padding-right: 8px;
    display: flex;
    justify-content: space-between;
  }
  .staticInfo {
    width: 100%;
    height: 250px;
    .tableInfo {
      width: 100%;
      height: 100%;
    }
  }
}
.infoview-left {
  right: auto;
  left: 10px;
}
/deep/ .ant-table-placeholder {
  padding: 40px 16px !important;
}
.cxfxClass input,
.cxfxClass select,
.cxfxClass textarea {
  color: #ffffff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
  font-size: 14px;
}

/deep/ .ant-col-4 {
  display: flex;
  flex-direction: row-reverse;
}
/deep/ .ant-col-20 {
  display: flex;
}
/deep/ .ant-table-wrapper,
/deep/ .ant-spin-nested-loading,
/deep/ .ant-spin-container,
/deep/ .ant-table,
/deep/ .ant-table-content,
/deep/ .ant-table-scroll {
  width: 100%;
  height: 100%;
}
</style>